import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const iconSize = 25;
const baseStyles = StyleSheet.create({
    progressComponentLowerText: { color: 'white', fontSize: 11 },
    progressComponentHigherText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 16
    },
    progressComponentGeneral: {
        color: 'white',
        fontWeight: 'bold'
    },
    progressComponentView: {
        justifyContent: 'center'
    },
    text: {
        fontSize: Theme.fontSizes.button
    },
    button: {
        marginVertical: 10
    },
    iconContainer: {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        width: iconSize + Theme.BU / 2
    },
    icon: {
        width: iconSize,
        height: iconSize
    }
});

export default baseStyles;
